module.exports = __webpack_public_path__ + "static/media/bnr_syun1232368f7f7a09ad9c218caf284a5615.webp";